import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from "./components/Header";
import FooterSection from './components/FooterSection';
import Home from './pages/Home';
import IntroductionSection from './pages/IntroductionSection';
import MissionVisionPage from './pages/MissionVisionPage';
import GallerySection from './pages/GallerySection';
import LibrarySection from './pages/LibrarySection';
import ClassRoomSection from './pages/ClassRoomSection';
import CourseDetailsSection from './pages/CourseDetailsSection';
import PrincipalMessage from './pages/PrincipalMessage';
import DirectorMessage from './pages/DirectorMassage';
import AdmissionProcessPage from './pages/AdmissionProcessPage';
import GameSportsSection from './pages/GameSportsSection';
import RegistrationSection from "./pages/RegistrationSection";
import Prospectus from "./pages/Prospectus";
import FeeRefundPolicyPage from './pages/FeeRefundPolicyPage';
import FeeStructure from "./pages/FeeStructure";
import NewsSection from './pages/NewsSection ';
import Committee from "./pages/Committee";
import ContactSection from './components/ContactSection';
import EnquiryPopup from './components/EnquiryPopup'; 
import EnquiryForm from "./components/EnquiryForm";
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import Sitemap from './pages/Sitemap';
import ContactFloatingButtons from './components/ContactFloatingButtons';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <EnquiryPopup />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/introduction" element={<IntroductionSection />} />
          <Route path="/mision-vision" element={<MissionVisionPage />} />
          <Route path="/contact" element={<ContactSection />} />
          <Route path="/gallery" element={<GallerySection />} />
          <Route path="/library" element={<LibrarySection />} />
          <Route path="/classroom" element={<ClassRoomSection />} />
          <Route path="/course-details" element={<CourseDetailsSection />} />
          <Route path="/enquiry" element={<EnquiryPopup />} />
          <Route path="/principal" element={<PrincipalMessage />} />
          <Route path="/director" element={<DirectorMessage />} />
          <Route path="/admisionprocess" element={<AdmissionProcessPage />} />
          <Route path="/gamespots" element={<GameSportsSection />} />
          <Route path="/registration" element={<RegistrationSection />} />
          <Route path="/prospectus" element={<Prospectus />} />
          <Route path="/free-refund" element={<FeeRefundPolicyPage />} />
          <Route path="/fee-structure" element={<FeeStructure />} />
          <Route path="/news" element={<NewsSection />} />
          <Route path="/commitee" element={<Committee />} />
          <Route path='/enquiryform'element={<EnquiryForm/>}/>
          <Route path='/privacy'element={<PrivacyPolicy/>}/>
          <Route path='/terms'element={<TermsConditions/>}/>
          <Route path="/sitemap"element={<Sitemap/>}/>
        </Routes>
        <FooterSection />
        <ContactFloatingButtons/>
      </div>
    </Router>
  );
}

export default App;